module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1048-05ebebe62921f53ec32f1584c525fe24.png";